import { useCallback } from "react";

/**
 * Horizontal resize drag handler.
 * - `start`: width of the left column (handle on its right edge). Drag right → wider.
 * - `end`: width of the right column (handle on its left edge). Drag right → narrower.
 */
export function useHorizontalPanelResize(currentSize, setSize, edge = "start") {
  const direction = edge === "end" ? -1 : 1;

  return useCallback(
    (event) => {
      event.preventDefault();
      const startX = event.clientX;
      const startSize = currentSize;
      document.body.classList.add("ws-is-resizing");

      const onMove = (ev) => {
        setSize(startSize + direction * (ev.clientX - startX));
      };

      const onUp = () => {
        document.body.classList.remove("ws-is-resizing");
        window.removeEventListener("pointermove", onMove);
        window.removeEventListener("pointerup", onUp);
        window.removeEventListener("pointercancel", onUp);
      };

      window.addEventListener("pointermove", onMove);
      window.addEventListener("pointerup", onUp);
      window.addEventListener("pointercancel", onUp);
    },
    [currentSize, setSize, direction]
  );
}
